import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const corporateData: NavItem[] = [
  {
    label: 'Hero',
    to: '/pages/corporate/hero'
  },
  {
    label: 'Vision-top',
    to: '/pages/corporate/visionTop'
  },
  {
    label: 'Vision-bottom',
    to: '/pages/corporate/visionBottom'
  },
  {
    label: 'Report',
    to: '/pages/corporate/report'
  },
  {
    label: 'Teams',
    to: '/pages/corporate/teams'
  }
];
